import React, { FC } from 'react';
import { Tooltip } from '@beeline.com/bp-design-system';
import { useHistory } from 'react-router-dom';
import { useTenantCode } from 'utils/hooks/useTenantConfig';
import { StyledOcAnchor } from 'common/Link';
import { RateCardModel } from '@utmost.co/enterprise-models';
import { ENGAGEMENTS_TAB, PATH_SCHEMA } from 'src/components/pages/settings/Engagements/EngagementsHome.constants';
import { navItems } from 'src/components/pages/settings/Engagements/EngagementsHome.paths';

interface Props {
  rateCard: RateCardModel;
}

export const RateCardNumRates: FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const { push } = useHistory();
  const tenantCode = useTenantCode();

  const path = navItems.find((n) => n.path === ENGAGEMENTS_TAB.RATE_CARDS)?.path;
  const sideDrawerRoute = `/${tenantCode}${PATH_SCHEMA}/${path}/details/${rateCard.uid}`;

  const tooltip = (
    <>
      {rateCard?.rates?.items?.map((r, index) => (
        <div key={r.code + r.name}>
          {index + 1}. {r.name}
        </div>
      ))}
    </>
  );

  return (
    <Tooltip title={tooltip} placement="bottom">
      <StyledOcAnchor
        onClick={() => {
          push({ pathname: sideDrawerRoute, state: rateCard });
        }}
        data-test="cell-rate-card-num-rates"
      >
        {rateCard?.rates?.items?.length.toString() ?? '-'}
      </StyledOcAnchor>
    </Tooltip>
  );
};
